// ToastContext.js
import React, { createContext, useContext, useRef } from "react";
import { Toast } from "primereact/toast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const toast = useRef(null);

  const addToast = (message, title = "Notification", type = "info", time = 5000) => {
    if (!toast.current || typeof toast.current.show !== "function") {
      console.warn(`[ToastContext] Toast instance not ready. Skipped toast: [${title}] ${message}`);
      return;
    }

    switch (type) {
      case "success":
        toast.current.show({ severity: "success", summary: title, detail: message, life: time });
        break;
      case "error":
        toast.current.show({ severity: "error", summary: title, detail: message, life: time });
        break;
      case "info":
        toast.current.show({ severity: "info", summary: title, detail: message, life: time });
        break;
      case "warn":
        toast.current.show({ severity: "warn", summary: title, detail: message, life: time });
        break;
      default:
        toast.current.show({ severity: "info", summary: title, detail: message, life: time });
    }
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      <Toast ref={toast} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
